import ContentModel from '../content/index.model.js';
import FacetModel from '../facet/index.model.js';
import PersonalizationModel from '../personalization/index.model.js';
import RankingModel from '../ranking/index.model.js';
import RuleModel from '../rule/index.model.js';
import QueryModel from '../searchQuery/query.model.js';
import SortModel from '../sort/index.model.js';
import SuggestionModel from '../suggestion/index.model.js';
import SwatchModel from '../swatch/index.model.js';
const model = {
    name: 'Search',
    properties: {
        sort: { type: 'model', model: SortModel },
        content: { type: 'model', model: ContentModel },
        facet: { type: 'model', model: FacetModel },
        filter: {},
        group_by: {},
        limit: {},
        offset: {},
        personalization: { type: 'model', model: PersonalizationModel },
        query: { type: 'model', model: QueryModel },
        ranking: { type: 'array', model: RankingModel },
        rule: { type: 'model', model: RuleModel },
        suggestion: { type: 'array', model: SuggestionModel },
        swatch: { type: 'model', model: SwatchModel },
    },
};
export default model;
